/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { CmlContent } from '__generated__/graphql-types-do-not-use';

import { Typography } from '@coursera/cds-core';

import TrackedDiv from 'bundles/page/components/TrackedDiv';
import Subsection from 'bundles/unified-description-page-common/components/shared/Subsection';
import TogglableDescription from 'bundles/unified-description-page-common/components/shared/TogglableDescription';

import _t from 'i18n!nls/xdp';

type Props = {
  title?: string;
  productId: string;
  description?: string | null;
  cmlDescription?: CmlContent | null;
};

const Description = ({ productId, description, cmlDescription, title }: Props) => {
  if (!description && !cmlDescription) {
    return null;
  }

  return (
    <Subsection title={<Typography variant="h2semibold">{title ?? _t("What you'll learn")}</Typography>}>
      <TrackedDiv
        trackingName="what_you_will_learn_section"
        withVisibilityTracking={true}
        requireFullyVisible={false}
        trackClicks={false}
      >
        <TogglableDescription productId={productId} description={description} cmlDescription={cmlDescription} />
      </TrackedDiv>
    </Subsection>
  );
};

export default Description;
